module.exports = "/* .panel-heading .fa {\n  transition: .3s transform ease-in-out;\n}\n  \n.panel-heading .collapsed .fa {\n   transform: rotate(90deg);\n}\n*/\n.no-underline {\n    text-decoration: none;\n    cursor: pointer;\n}\n.toggle-container {\n  background-color:white;\n  /* border:10px solid black; */\n  /* width:200px; */\n  /* text-align:center; */\n  /* line-height:100px; */\n  /* font-size:50px; */\n  -webkit-box-sizing:border-box;\n          box-sizing:border-box;\n  overflow:hidden;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/filter-list/filter-list.component.css
// module id = ./src/app/shared/components/filter-list/filter-list.component.css
// module chunks = main